import React from "react";
import Header from "./Header";
import GlobalStyles from "../styles/GlobalStyles";
import BottomSection from "./BottomSection";
import styled from "styled-components";

const StyledLayout = styled.div`
  background: var(--background-color);
  padding-bottom: 1rem;
`;

const Layout = ({ children }) =>{
    return <StyledLayout>
        <GlobalStyles/>
        <Header/>
        {children}
        <BottomSection/>
    </StyledLayout>
}

export default Layout;